export default __webpack_public_path__ + "static/media/480_dummy2016-physiotherapie01-mobile-de.4eb17f95.png";